'use client';
import React, { useState } from 'react';

import CalendarSelectItem from './CalendarSelectItem';
import { useTranslations } from 'next-intl';
import { useGetCalendarEvent } from '../../../../hooks/event/use-get-calendar-event.hook';
import { CALENDAR_DAYS } from '@wwe-portal/web/utils/calendar/contant';

function CalendarSelect() {
  const { eventsTypes } = useGetCalendarEvent();
  const [activeSelectItem, setActiveSelectItem] = useState('');

  const t = useTranslations();

  return (
    <div className="calendar__select md:rounded-xl">
      <h5 className="calendar__select__header md:border-b-solid text-base font-medium capitalize md:border-b-[1px] md:border-b-[#31365e]">
        {t('select_a_date')}
      </h5>

      <div className="calendar__select__overflow">
        <div className="my-[30px] flex w-[700px] flex-row gap-1 overflow-x-scroll py-0 md:w-full md:px-[15px] min-[1620px]:flex-col min-[1620px]:p-0">
          <CalendarSelectItem
            id="show_all"
            href={CALENDAR_DAYS.today.id}
            eventsDay={t('show_all')}
            isActive={!activeSelectItem}
            onClick={() => setActiveSelectItem('')}
            visible
          />
          {Object.values(CALENDAR_DAYS).map(({ id, key }) => {
            return (
              <CalendarSelectItem
                id={id}
                key={id}
                eventsDay={t(key)}
                isActive={activeSelectItem === key}
                onClick={() => setActiveSelectItem(key)}
                visible={eventsTypes[key] && eventsTypes[key].length > 0}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CalendarSelect;
